import { ImpactShopProductType } from "@ecologi/shared";
import { GetServerSidePropsContext } from "next";
import { ImpactShopProductPage } from "../../../features";
import { getImpactShopProduct } from "../../../lib";
import { withLogging } from "../../../lib/ssr/logGetServerSideProps";
import { getAuth0AccessToken } from "../../../lib/auth0";

type ImpactShopProductPageComponentProps = {
  isLoggedIn: boolean;
  product: ImpactShopProductType;
};

const ImpactShopProductPageComponent = ({
  product,
  isLoggedIn,
}: ImpactShopProductPageComponentProps) => (
  <ImpactShopProductPage isLoggedIn={isLoggedIn} product={product} />
);

const redirectToImpactShop = {
  redirect: {
    destination: "/impact-shop",
    permanent: false,
  },
} as const;

export const getServerSideProps = withLogging(
  async ({ params, req, res }: GetServerSidePropsContext) => {
    const accessToken = await getAuth0AccessToken(req, res);

    try {
      const product = await getImpactShopProduct(
        params.slug as string,
        accessToken ?? undefined
      );

      if (!product) {
        return redirectToImpactShop;
      }

      return {
        props: {
          layoutProps: {
            hideHeader: true,
            isWhiteBody: true,
            isProfile: true,
          },
          isLoggedIn: Boolean(accessToken),
          product,
        },
      };
    } catch {
      return redirectToImpactShop;
    }
  }
);

export default ImpactShopProductPageComponent;
